// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-ColorView-ColorView-module__preview--WEEnD {
  border: thin solid #d9d9d9;
  width: 100%;
  aspect-ratio: 1;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/ColorView/ColorView.module.less"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,WAAA;EACA,eAAA;AACF","sourcesContent":[".preview {\n  border: thin solid #d9d9d9;\n  width: 100%;\n  aspect-ratio: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `src-common-attributes-makeAttrLabel-labelMakers-ColorView-ColorView-module__preview--WEEnD`
};
export default ___CSS_LOADER_EXPORT___;
